module.exports = __webpack_public_path__ + "img/targetGreen.e75a29c1.jpg";